/**
 * Trade-In Option - Product Page Script
 *
 * Handles:
 * 1. Checkbox toggle to activate/deactivate trade-in discount
 * 2. Dynamic price display update on the product page
 * 3. Hidden input management for _trade_in and _trade_in_agreement properties
 * 4. Variant change tracking to recalculate trade-in price
 */
(function () {
  "use strict";

  var tradeInOption = document.getElementById("trade-in-option");
  if (!tradeInOption) return;

  var checkbox = document.getElementById("trade-in-checkbox");
  var agreementInput = document.getElementById("trade-in-agreement");
  var discountOption = tradeInOption.dataset.tradeInDiscountOption || '割合';
  var discountRate = parseInt(tradeInOption.dataset.tradeInDiscountRate, 10) || 30;
  var discountAmount = parseInt(tradeInOption.dataset.tradeInDiscountAmount, 10) || 0;

  function calcDiscountedPrice(price) {
    if (discountOption === '定額') {
      return Math.max(0, price - discountAmount);
    }
    return Math.floor(price * (100 - discountRate) / 100);
  }

  /**
   * Format a Shopify price (in cents/subunits) to JPY format
   */
  function formatMoney(cents) {
    return "¥" + Math.floor(cents / 100).toLocaleString("ja-JP");
  }

  /**
   * Get the current variant price from the product JSON or URL
   */
  function getCurrentVariantPrice() {
    var productJson = window.product;
    if (!productJson) return null;

    // Check URL for variant parameter
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get("variant");

    if (variantId) {
      var variant = productJson.variants.find(function (v) {
        return v.id === parseInt(variantId, 10);
      });
      if (variant) return variant.price;
    }

    // Fallback: use selected option from the form select
    var selectEl = document.querySelector('[name="id"]');
    if (selectEl) {
      var selectedVariantId = parseInt(selectEl.value, 10);
      var selectedVariant = productJson.variants.find(function (v) {
        return v.id === selectedVariantId;
      });
      if (selectedVariant) return selectedVariant.price;
    }

    // Fallback: first available variant
    var firstAvailable = productJson.variants.find(function (v) {
      return v.available;
    });
    return firstAvailable ? firstAvailable.price : productJson.variants[0].price;
  }

  /**
   * Update the trade-in price display elements
   */
  function updatePriceDisplay(price) {
    if (!price) return;

    var originalPriceEl = tradeInOption.querySelector("[data-trade-in-original-price]");
    var discountedPriceEl = tradeInOption.querySelector("[data-trade-in-discounted-price]");

    if (originalPriceEl) {
      originalPriceEl.textContent = formatMoney(price);
    }
    if (discountedPriceEl) {
      discountedPriceEl.textContent = formatMoney(calcDiscountedPrice(price));
    }

    tradeInOption.dataset.originalPrice = price;
  }

  /**
   * Update the main product page price display
   */
  function updateProductPagePrice(isTradeIn) {
    var price = getCurrentVariantPrice();
    if (!price) return;

    // Target all price display elements on the product page
    var priceDefaultEls = document.querySelectorAll(
      ".price-item.price-default[data-regular-price], .product-price-v2-default"
    );

    priceDefaultEls.forEach(function (el) {
      if (isTradeIn) {
        if (!el.dataset.originalPriceText) {
          el.dataset.originalPriceText = el.textContent.trim();
        }
        var discountedPrice = calcDiscountedPrice(price);
        el.innerHTML =
          '<span style="text-decoration:line-through;color:#86868b;font-size:0.85em;">' +
          formatMoney(price) +
          "</span> " +
          '<span style="color:#bf4800;font-weight:bold;">' +
          formatMoney(discountedPrice) +
          "</span>";
      } else {
        if (el.dataset.originalPriceText) {
          el.textContent = el.dataset.originalPriceText;
          delete el.dataset.originalPriceText;
        }
      }
    });

    // Also update the sale price elements if visible
    var salePriceEls = document.querySelectorAll(
      ".price-item.price-item--sale[data-sale-price]"
    );
    salePriceEls.forEach(function (el) {
      if (isTradeIn) {
        if (!el.dataset.originalSaleText) {
          el.dataset.originalSaleText = el.textContent.trim();
        }
        var discountedPrice = calcDiscountedPrice(price);
        el.textContent = formatMoney(discountedPrice);
      } else {
        if (el.dataset.originalSaleText) {
          el.textContent = el.dataset.originalSaleText;
          delete el.dataset.originalSaleText;
        }
      }
    });
  }

  /**
   * Toggle trade-in state
   */
  function toggleTradeIn() {
    var isChecked = checkbox.checked;
    var couponCode = tradeInOption.dataset.tradeInCouponCode;

    // Toggle visual state
    if (isChecked) {
      tradeInOption.classList.add("trade-in-option--active");
      document.body.classList.add("trade-in-active");
    } else {
      tradeInOption.classList.remove("trade-in-option--active");
      document.body.classList.remove("trade-in-active");
    }

    // Manage hidden inputs for cart properties
    if (isChecked) {
      checkbox.removeAttribute("disabled");
      agreementInput.removeAttribute("disabled");
      agreementInput.value = "agreed";
    } else {
      // When unchecked, disable the inputs so they aren't sent with the form
      agreementInput.setAttribute("disabled", "");
      agreementInput.value = "";
    }

    // Update price display
    updateProductPagePrice(isChecked);

    // Apply/clear discount code asynchronously (for Express Checkout support)
    if (couponCode) {
      if (isChecked) {
        fetch('/discount/' + encodeURIComponent(couponCode), {
          credentials: 'include'
        });
        sessionStorage.setItem('trade_in_discount_applied', couponCode);
      } else {
        fetch('/discount/CLEAR-TRADE-IN', { credentials: 'include' });
        sessionStorage.removeItem('trade_in_discount_applied');
      }
    }

    // Update cart attributes for Checkout Box integration
    var couponCodeForAttr = tradeInOption.dataset.tradeInCouponCode;
    var cartAttributes = {};
    if (isChecked) {
      cartAttributes["下取り規約への同意"] = "同意済み";
      cartAttributes["下取りクーポンコード"] = couponCodeForAttr || "";
    } else {
      cartAttributes["下取り規約への同意"] = "";
      cartAttributes["下取りクーポンコード"] = "";
    }
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: cartAttributes }),
    });
  }

  /**
   * Listen for variant changes (URL mutation)
   */
  function observeVariantChanges() {
    var href = location.href;

    var observer = new MutationObserver(function () {
      if (href !== location.href) {
        href = location.href;
        var price = getCurrentVariantPrice();
        if (price) {
          updatePriceDisplay(price);
          if (checkbox.checked) {
            updateProductPagePrice(true);
          }
        }
      }
    });

    observer.observe(document, { childList: true, subtree: true });
  }

  // Initialize
  checkbox.addEventListener("change", toggleTradeIn);

  // Set initial state
  var initialPrice = getCurrentVariantPrice();
  if (initialPrice) {
    updatePriceDisplay(initialPrice);
  }

  observeVariantChanges();
})();
